import { render } from "./TemplateDbsIndex.vue?vue&type=template&id=1ba10612"
import script from "./TemplateDbsIndex.vue?vue&type=script&lang=js"
export * from "./TemplateDbsIndex.vue?vue&type=script&lang=js"
script.render = render

export default script